var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('KeyWordSearch',{ref:"postalcode",attrs:{"enabled":[true,false,false,false],"default_values":_vm.default_values.word.keywords},on:{"quantity":_vm.updateCant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }